// import firebase from "firebase/app";
// import firebase from 'firebase/compat/app';
import firebase from 'firebase/app';
import config from '../../firebase.config.json';

// ----------------------------- o

export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();
// export default firebase.initializeApp(config)

console.log('______________Firebase - config - 1 - ', config)
